import { Button, FlexBox, Input } from "@ui5/webcomponents-react"
import i18n from '../../../../services/i18n'

export default function ForgotEmail({ onSubmit, error, close, loading }) {

    console.log('rendering 0')

    return (
        <FlexBox
            direction="Column"
            alignItems="Center"
            justifyContent="Center"
            style={{ height: '100vh', backgroundColor: '#f1f1f1f1' }}
        >
            <FlexBox
                direction="Column"
                justifyContent="Center"
                alignItems="Center"
                style={{
                    backgroundColor: '#fff',
                    padding: 40,
                    borderRadius: 10,
                    border: '1px solid #ccc',
                    paddingBottom: 30
                }}
            >


                <img
                    style={{ height: 100, resize: 'contain' }}

                    src="/logo-large.png"
                    alt="Workflow"
                />

                <label style={{ fontWeight: 'bold', marginBottom: 10, marginTop: 20 }}>{i18n.t('insertEmail')}</label>

                <Input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    placeholder="Email"
                />

                <Button
                    onClick={onSubmit}
                    disabled={loading}
                    icon="open-command-field"
                    style={{ marginTop: '1rem', width: '100%' }}
                >
                    {
                        loading
                            ?
                            i18n.t('loading')
                            :
                            i18n.t('next')
                    }
                </Button>
                <FlexBox
                    direction="Row"
                    justifyContent="SpaceBetween"
                    alignItems="Center"
                    style={{ width: '100%', marginTop: '1rem' }}

                >
                    <Button
                        icon="arrow-left"
                        design="Emphasized"
                        onClick={close}
                        style={{ width: '100%' }}
                    >{i18n.t('back')}</Button>
                </FlexBox>
            </FlexBox>
        </FlexBox>
    )

}